import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';
import moment from 'moment';

const COLABORADOR = 'COLABORADOR';
const LISTADO = 'LISTADO';
const PUESTO = 'PUESTO';
const SUELDO = 'SUELDO';
const BONIFICACION = 'BONIFICACION';
const FRECUENCIA_PAGO = 'FRECUENCIA_PAGO';
const LOADER = 'LOADER';
const LOADER_REP = 'LOADER_REP';
const MODULO = 'MODULO';
const LECTURA = 'LECTURA';
const LISTADO_PERIODOS = 'LISTADO_PERIODOS';
const PERIODO_D = 'PERIODO_D';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

const setLoaderRep = loaderRep => ({
    type: LOADER_REP,
    loaderRep,
});


export const listarColaborador = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id };
    
    api.get('/colaborador/empresa_colaborador_pais', params).then(data => {
        const lista = [];
        if (data) {
            data.forEach(item => {
                lista.push({
                    value: item.id,
                    label: item.codigo+' - ' + item.nombre
                })
            })
        }
        dispatch({type: COLABORADOR, emp: lista })
    }).catch((error) => {
        return [];
    })
}

export const datosColaborador = (emp) => (dispatch) => {
    api.get(`/colaborador/${emp}`).then((response) => {
        dispatch({type: PUESTO, cargo: response.cargo });
        dispatch({type: SUELDO, sueldo: response.sueldoBase });
        dispatch({type: FRECUENCIA_PAGO, frecuencia: response.frecuenciaPago });
        let bono = 0.00
        if (parseFloat(response.bonificacion) >= 251.00){
            bono = 250.000
        }else{
            bono = parseFloat(response.bonificacion)
        }
        dispatch({type: BONIFICACION, bonificacion: bono });
    }).catch((error) => {
        return [];
    })
}

export const registroDescuento = (horas, periodo) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormDescuentoHora.values;
    let fechaI = moment(periodo.fecha_inicio);
    let fechaF = moment(periodo.fecha_fin);
    let fecha = moment(data.fecha);
    if (fecha >= fechaI && fecha <= fechaF) {

        let id_empresa = id_emp[5]
        
        if (data === undefined) {
            Swal.fire({
                title: 'Descuento por hora',
                text: 'Debe de seleccionar colaborador',
                type: 'error',
            })
        } else {
            if (data.fecha === undefined || data.fecha === '') {
                Swal.fire({
                    title: 'Descuento por hora',
                    text: 'Debe de ingresar fecha',
                    type: 'error',
                })
            } else {
                const formData = {
                    colaborador: data.colaborador.value,
                    fecha: data.fecha,
                    motivo: data.motivo,
                    frecuencia: data.frecuencia,
                    horas: horas,
                    observacion: data.observaciones,
                    empresa: id_empresa
                }
                dispatch(setLoader(true));
                api.post('/rrhh_descuento_hora/', formData).then(() => {
                    NotificationManager.success(
                        'Falta creada correctamente',
                        'Exito',
                        3000
                    );
                    let ruta = `/rr_hh/${id_emp[5]}/descuento_hora/${id_emp[7]}`
                    dispatch(push(ruta));
                }).catch((error) => {
                NotificationManager.error(
                    error.msj,
                    'Error',
                    0
                );
                }).finally(() => {
                    dispatch(setLoader(false));
                });
            }
        }
    }else{
        Swal.fire({
            title: 'Descuento por hora',
            text: 'Fecha fuera del periodo',
            type: 'error',
        })
    }
}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    
    let id = id_emp[5];
    let periodo = id_emp[7];
    let params = { id, periodo };
    dispatch(setLoader(true));
    api.get('/rrhh_descuento_hora/', params).then((response)=>{
        dispatch({type: LISTADO, data: response })
    }).catch(error=>{
        NotificationManager.error(
            'Ocurrió un error al listar descuentos',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/rrhh_descuento_hora/${id}`).then((response) => {
        dispatch(datosColaborador(response.colaborador));
        dispatch({type: LECTURA, lectura: response})
        dispatch(initializeForm('FormDescuentoHora', response ));
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al consultar descuento',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

const limpiarDatos = () => (dispatch) => {
    dispatch({ type: PUESTO, cargo: [] });
    dispatch({ type: SUELDO, sueldo: 0.00 });
    dispatch({ type: BONIFICACION, bonificacion: 0.00 });
    dispatch({type: FRECUENCIA_PAGO, frecuencia: '' });
};

const eliminar = id => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`/rrhh_descuento_hora/${id}`).then(() => {
        NotificationManager.success(
            'Descuento por hora eliminado correctamente',
            'Exito',
            3000
        );
        dispatch(listar());
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error al eliminar descuento',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const modificarDescuento = (horas, periodo) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormDescuentoHora.values;
    let fechaI = moment(periodo.fecha_inicio);
    let fechaF = moment(periodo.fecha_fin);
    let fecha = moment(datos.fecha);
    if (fecha >= fechaI && fecha <= fechaF) {

        const id = datos.id;

        if (datos.fecha === undefined || datos.fecha === '') {
            Swal.fire({
                title: 'Descuento por hora',
                text: 'Debe de ingresar fecha de inicio',
                type: 'error',
            })
        } else {
            const formData = {
                id: id,
                fecha: datos.fecha,
                frecuencia: datos.forma_descuento,
                horas: horas,
                observacion: datos.observaciones,
            }
            dispatch(setLoader(true));
            api.put(`/rrhh_descuento_hora/${id}/`, formData).then(() => {
                NotificationManager.success(
                    'Descuento por hora modificado correctamente',
                    'Exito',
                    3000
                );
                let ruta = `/rr_hh/${id_emp[5]}/descuento_hora/${id_emp[7]}`
                dispatch(push(ruta));
            }).catch((error) => {
                NotificationManager.error(
                    error.msj,
                    'Error',
                    0
                );
            }).finally(() => {
                dispatch(setLoader(false));
            });
        }
    }else{
        Swal.fire({
            title: 'Descuento por hora',
            text: 'Fecha fuera del periodo',
            type: 'error',
        })
    }
}

export const listarPeriodos = (year) => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id, year };
    dispatch(setLoader(true));
    api.get('/periodos/periodo_empresa_year', params).then((response)=>{
        let periodo = [];
        response.forEach(item=>{
            periodo.push({
                value: item.id,
                label: item.periodo
            })
        })
        dispatch({ type: LISTADO_PERIODOS, periodos: periodo });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar los periodos',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leerPeriodoD = (id, id_periodo) => (dispatch) => {
    const params = { id, id_periodo };
    api.get('/periodos/periodo', params).then((response) => {
        dispatch({ type: PERIODO_D, periodoD: response.periodo });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al consultar periodo',
            'Error',
            2000
        );
    })
}

export const reporteDescuentoHoras = () => (dispatch,getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const data = getStore().form.FormListaDescuentosHora.values;
    
    let reporte = 'reporteDescuentoHoras';
    let periodo = data.periodo
    let emp = data.colaborador ? data.colaborador.value : '';
    let frecuencia = data.frecuencia
    const params = { id, reporte, periodo, emp, frecuencia }
    dispatch(setLoaderRep(true));
    api.getPdf('/rrhh_reportes', params).then((response) => {
        if (response.headers['content-type'] == 'application/pdf') {
            var blob = new Blob([response.text], { type: 'application/pdf;charset=utf-8' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'reporte_descuento_horas.pdf';
            window.open(link, '_blank');
            return false;
        }
    }).catch((error) => {
        if (error.status === 404) {
            NotificationManager.error(
                "No se encontraron datos",
                "Error",
                2000
            );
        }
        if (error.status === 500) {
            NotificationManager.error(
                'Ocurrió un error al generar reporte',
                'Error',
                0
            );
        }
  
    }).finally(() => {
        dispatch(setLoaderRep(false));
    });
}

export const listarColaboradorReporte = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id, search };
    
    return api.get('/colaborador/buscar_colaborador_nomina',params).then(data=>{
        const list_emp = [];
        if(data){
            data.forEach(item=>{
                list_emp.push({
                    value: item.id,
                    label:  item.codigo+' - ' + item.nombre
                })
            })
        }
        return list_emp;
    }).catch((error)=>{
        return [];
    })
}

export const actions = {
    listarColaborador,
    getModulo,
    registroDescuento,
    datosColaborador,
    listar,
    leer,
    limpiarDatos,
    eliminar,
    modificarDescuento,
    listarPeriodos,
    leerPeriodoD,
    reporteDescuentoHoras,
    listarColaboradorReporte
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LOADER_REP]: (state, { loaderRep }) => {
        return {
            ...state,
            loaderRep,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [COLABORADOR]: (state, { emp }) => {
        return {
            ...state,
            emp,
        };
    },
    [PUESTO]: (state, { cargo }) => {
        return {
            ...state,
            cargo,
        };
    },
    [SUELDO]: (state, { sueldo }) => {
        return {
            ...state,
            sueldo,
        };
    },
    [BONIFICACION]: (state, { bonificacion }) => {
        return {
            ...state,
            bonificacion,
        };
    },
    [FRECUENCIA_PAGO]: (state, { frecuencia }) => {
        return {
            ...state,
            frecuencia,
        };
    },
    [LISTADO]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [LECTURA]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [LISTADO_PERIODOS]: (state, { periodos }) => {
        return {
            ...state,
            periodos,
        };
    },
    [PERIODO_D]: (state, { periodoD }) => {
        return {
            ...state,
            periodoD,
        };
    },
};

export const initialState = {
    loader: false,
    loaderRep: false,
    modulo: [],
    data: [],
    emp: [],
    lectura: [],
    periodos: [],
    periodoD: [],
    sueldo: 0.00,
    bonificacion: 0.00,
    frecuencia: ''
};

export default handleActions(reducers, initialState)
 